import script from "./WhyPlateau.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhyPlateau.vue?vue&type=script&setup=true&lang=ts"

import "./WhyPlateau.vue?vue&type=style&index=0&id=5b0cf0e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b0cf0e8"]])

export default __exports__